import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { trackEvent } from '../services/tracking';

/**
 * Mount inside the Router. Fires a server-side page_view event on every
 * route change (anonymous or authenticated). No data is stored in the browser.
 */
const RouteTracker = () => {
  const location = useLocation();

  useEffect(() => {
    trackEvent('page_view', { path: location.pathname });
  }, [location.pathname]);

  return null;
};

export default RouteTracker;
